module.exports = __webpack_public_path__ + "img/33.dab20530.svg";